import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTrail, animated } from 'react-spring';
import Star from './common/Star';

function StarRating(props) {
  const { value, onChange, readOnly } = props;

  if (readOnly) {
    const stars = Array(5).fill(0);
    return (
      <div className="StarRating">
        {stars.map((zero, index) => (
          <Star
            active={index + 1 <= value}
            onClick={e => {
              e.stopPropagation();
            }}
            key={index}
          />
        ))}
      </div>
    );
  }

  const [hovered, setHover] = useState(undefined);
  const AnimatedStar = animated(Star);
  const animatedStars = useTrail(5, {
    config: {
      friction: 22,
      tension: 500
    },
    from: { opacity: 0, transform: 'scale(0.8)' },
    opacity: 1,
    transform: 'scale(1)'
  });

  return (
    <div className="StarRating" onMouseLeave={() => setHover(undefined)}>
      {animatedStars.map((props, index) => (
        <AnimatedStar
          active={hovered ? index + 1 <= hovered : index + 1 <= value}
          onMouseEnter={() => setHover(index + 1)}
          onClick={e => {
            e.stopPropagation();
            setHover(undefined);
            onChange(index + 1);
          }}
          key={index}
          style={{ ...props }}
        />
      ))}
    </div>
  );
}

StarRating.propTypes = {
  readOnly: PropTypes.bool,
  value: PropTypes.number,
  onChange: PropTypes.func
};

export default StarRating;
